import { Form } from "@quillforms/renderer-core";
import "@quillforms/renderer-core/build-style/style.css";
import "./App.css";
import { useEffect } from 'react';
import { convertFormat, submitLeads } from './utils'; // Adjust the path as needed
import image from './images/vaginoplasty.webp'; // Ensure you have an appropriate image

export const VaginoPlastyForm = () => {
  useEffect(() => {
    document.title = 'Female Vaginoplasty Specialist in Gurgaon'; // Updated title
  }, []);
  return (
    <div style={{ width: "100%", height: "100vh" }}>

      <Form
        formId="2" // Updated formId
        formObj={{
          blocks: [
            {
              name: "welcome-screen",
              id: "bph1001r",
              attributes: {
                buttonText: "Next",
                label: "<b>Premier Vaginoplasty Surgeon in Gurgaon<b><br>🌟🌟🌟🌟🌟",
                customHTML: `<br><b>Dr. Shikha Bansal</b><br>
                MBBS, MS, MCh.<br>
                Plastic & Reconstructive Surgery<br>
                <h2>Restore Your Confidence!</h2>
                Compassionate & Confidential Care&nbsp;✅<br>
                Quick & Painless Procedure &nbsp;&nbsp;✅<br>
                Minimal Downtime &nbsp;&nbsp;✅<br>
                Quick Healing&nbsp;&nbsp;✅<br>
                `,
                attachment: {
                  type: "image",
                  url: image
                },
                attachmentMaxWidth: "300px"
              }
            },
            {
              "name": "multiple-choice",
              "id": "q_purpose",
              "attributes": {
                "required": true,
                "label": "Why are your reasons for exploring Vaginoplasty?",
                "choices": [
                  {"label": "Cosmetic reasons", "value": "cosmetic"},
                  {"label": "Medical reasons", "value": "medical"},
                  {"label": "Other", "value": "other"}
                ]
              }
            },
            {
              "name": "multiple-choice",
              "id": "q_age_group",
              "attributes": {
                "required": true,
                "label": "What age group are you in?",
                "choices": [
                  {"label": "Below 18", "value": "below_18"},
                  {"label": "18-30", "value": "18_to_30"},
                  {"label": "31-50", "value": "31_to_50"},
                  {"label": "51-65", "value": "51_to_65"},
                  {"label": "Above 65", "value": "above_65"}
                ]
              }
            },
            {
              "name": "multiple-choice",
              "id": "q_location",
              "attributes": {
                "required": true,
                "label": "Where are you located?",
                "choices": [
                  {"label": "Gurgaon", "value": "gurgaon"},
                  {"label": "Delhi", "value": "delhi"},
                  {"label": "Faridabad", "value": "faridabad"},
                  {"label": "Ghaziabad", "value": "ghaziabad"},
                  {"label": "Other", "value": "other"}
                ]
              }
            },
            {
              "name": "multiple-choice",
              "id": "q_when",
              "attributes": {
                "required": true,
                "label": "How soon are you looking for Vaginoplasty?",
                "choices": [
                  {"label": "As soon as possible", "value": "asap"},
                  {"label": "Within a week", "value": "within_a_week"},
                  {"label": "Within a month", "value": "within_a_month"},
                  {"label": "> 1 month", "value": "more_than_a_month"},
                  {"label": "Not sure", "value": "not_sure"}
                ]
              }
            },
            {
              "name": "multiple-choice",
              "id": "q_previous_procedures",
              "attributes": {
                "required": true,
                "label": "Have you had any previous Vaginoplasty procedure?",
                "choices": [
                  {"label": "Yes", "value": "yes"},
                  {"label": "No", "value": "no"}
                ]
              }
            },
            {
              name: "short-text",
              id: "name",
              attributes: {
                required: true,
                label: "What's your name?"
              }
            },
            {
              name: "number",
              id: "phone",
              attributes: {
                required: true,
                description: "We value your trust and privacy. Your phone number will be securely shared with our doctor for necessary communication only!",
                label: "What's your phone number?"
              }
            },
          ],
          messages: {
            'block.defaultThankYouScreen.label': 'Thank you! We will contact you shortly!'
          },
          settings: {
            animationDirection: "vertical",
            disableWheelSwiping: false,
            disableNavigationArrows: false,
            disableProgressBar: false,
            showQuestionsNumbers: true
          },
          theme: {
            font: "Roboto",
            questionsColor: "#1c3d5a",
            buttonsBgColor: "#1c3d5a",
            logo: {
              src: ""
            },
            answersColor: "#1c3d5a",
            buttonsFontColor: "#fff",
            buttonsBorderRadius: 25,
            errorsFontColor: "#fff",
            errorsBgColor: "#f00",
            progressBarFillColor: "#1c3d5a",
            progressBarBgColor: "#ccc"
          }
        }}
        onSubmit={(data, { completeForm, setIsSubmitting, setSubmissionErr }) => {
          let convertedData = convertFormat(data);
          convertedData['type'] = 'vaginoplasty'
          console.log(JSON.stringify(convertedData));
          let mode = window.location.hostname === 'localhost' ? 'dev' : 'prod';
          submitLeads(convertedData, { mode, targets: 'both', successPolicy: 'any', mockSuccess: true })
            .then(() => {
              setIsSubmitting(false);
              completeForm();
              setTimeout(() => {
                window.location.href = 'https://drshikhabansal.com';
              }, 3000);
            })
            .catch((error) => {
              setIsSubmitting(false);
              setSubmissionErr(error.message);
              console.error('Lead submission error details:', error.result || error);
            });
        }}
      />
    </div>
  );
};
